import React from 'react';
import {intervals} from "services/insight";
import {toTitleCase} from "services/string";
import {InsightInterval} from "types/OperatorInsights";

type Props = {
    id: string
    name: string
    label: string
    value: InsightInterval
    onChange: (interval: InsightInterval) => any
    disabledIntervals?: Array<InsightInterval>
}

function IntervalSelect({id, name, label, value, onChange, disabledIntervals}: Props) {
    return (
        <div>
            <label htmlFor={id} className="block text-sm font-medium text-gray-700">
                {label}
            </label>
            <select
                id={id}
                name={name}
                className="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-brand focus:outline-none focus:ring-brand sm:text-sm"
                value={value}
                onChange={event => onChange(event.currentTarget.value as InsightInterval)}
            >
                {intervals.map(interval => (
                    <option
                        value={interval}
                        key={interval}
                        disabled={disabledIntervals?.includes(interval)}
                    >
                        {toTitleCase(interval)}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default IntervalSelect;